<template>
  <div class="mx-3 min-h-screen">
    <div class="flex gap-4 justify-between bg-white p-4 rounded-t-md">
      <div class="flex gap-4">
        <input
          type="text"
          placeholder="Search document"
          class="rounded-full w-44 pl-4 py-1 bg-gray-200"
          v-model="searchQuery"
        />
        <select
            name=""
            id=""
            class="p-2 bg-gray-200 rounded-full w-full"
            v-model="KnowledgebaseCategory"
            required
        >
          <option value="" default selected>All</option>
          <option
              v-for="category in categories"
              :value="category.Name"
              :key="category.Id"
          >
            {{ category.Name }}
          </option>
        </select>
      </div>
      <button v-if="this.getUserRole.toLowerCase()==='hrmanager'"
        class="bg-primary text-white rounded-full w-44 text-sm"
        @click="showCreateKnowledgeBaseDocument = true"
      >
        Add Document
      </button>
    </div>
    <div class="p-3 rounded-b-md bg-white">
      <div
        v-if="!loading && filterItems.length === 0"
        class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>

      <ve-table v-else :columns="columns" :table-data="filterItems" />
    </div>
    <CreateKnowledgeBaseDoc
      @close="showCreateKnowledgeBaseDocument = false"
      :showCreateKnowledgeBaseDocument="showCreateKnowledgeBaseDocument"
      :reload="reload"
    >
    </CreateKnowledgeBaseDoc>
    <attachments-viewer
      :showAttachments="showAttachments"
      :attachmentUrl="attachmentUrl"
      :attachmentType="attachmentType"
      @close="showAttachments = false"
      :docTitle="docTitle"
    ></attachments-viewer>
  </div>
</template>

<script>
import CreateKnowledgeBaseDoc from "./createKnowledgeBaseDoc.vue";
import DocumentsDisplay from "@/utils/documentsDisplay.vue";
import AttachmentsViewer from "@/utils/attachmentsViewer.vue";

import axios from "axios";
import { mapGetters } from "vuex";
import mergePDFs from "@/utils/createPdfBlob";

export default {
  name: "KnowledgeBase",
  data() {
    return {
      loading: false,
      showCreateKnowledgeBaseDocument: false,
      showAttachments: false,
      attachmentType: "",
      categories:[],
      docTitle: "",
      searchQuery:"",
      KnowledgebaseCategory:"",
      expandOption: {
        trigger: "row",
        render: ({ row }) => {
          return (
            <div class="flex gap-5 p-3">
              <DocumentsDisplay
                deleteDocumentCallback={this.deleteDocument}
                document={{
                  url: row.Attachment,
                  DocumentType: "",
                  documentId: row.Id,
                }}
                openPDFViewer={this.openPDFViewer}
              ></DocumentsDisplay>
            </div>
          );
        },
      },
      allColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",

          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "",
          key: "Attachment",
          title: "Attachment",
          width: 50,
          align: "left",
          renderBodyCell: ({ row }) => {
            return (
              <div class="flex gap-5">
                <DocumentsDisplay
                  deleteDocumentCallback={this.deleteDocument}
                  document={{
                    url: row.Attachment,
                    DocumentType: "",
                    documentId: row.Id,
                    document: row,
                  }}
                  showDeleteIcon={false}
                  openPDFViewer={this.openPDFViewer}
                  displayWidth={16}
                  paddingX={0.5}
                  paddingY={0.5}
                ></DocumentsDisplay>
              </div>
            );
          },
        },
        {
          field: "Description",
          key: "d",
          title: "Description",
          align: "left",
        },
        {
          field: "KnowledgeBaseCategory",
          key: "a",
          title: "Category",
          align: "left",
        },
        {
          title: "Action",
          field: "",
          key: "action",
          userRestricted: true,
          renderBodyCell: ({ row }) => (
              <ve-popper
                  trigger="clickToOpen"
                  options={{
                    placement: "top",
                    modifiers: { offset: { offset: "0,10px" } },
                  }}
              >
                <div class="bg-white p-2 shadow-md popper">

                  <button
                      class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                      style="boder-radius: 0 !important"
                      onClick={() => this.deleteDocument(row.Id)}
                  >
                    Delete
                  </button>
                </div>

                <button slot="reference">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                  >
                    <circle cx="12" cy="2" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="22" r="2" />
                  </svg>
                </button>
              </ve-popper>
          ),
        },
      ],
      tableData: [],
    };
  },
  components: { CreateKnowledgeBaseDoc, AttachmentsViewer },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getUserRole"]),
    columns(){
      return this.allColumns.filter(
          col=>!col.userRestricted || this.getUserRole.toLowerCase()==="hrmanager"
      )
    },
    filterItems() {
      console.log(this.getUserRole)
      return this.tableData.filter((item) => {
        const matchesCategory = this.KnowledgebaseCategory
            ? item.KnowledgeBaseCategory === this.KnowledgebaseCategory
            : true;

        const matchesSearch = this.searchQuery
            ? item.Description.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            item.KnowledgeBaseCategory.toLowerCase().includes(this.searchQuery.toLowerCase())
            : true;

        return matchesCategory && matchesSearch;
      });
    },
  },
  created() {
    this.getCategory();
    this.getDocuments();

  },
  methods: {
    // /{organization}/company/knowledgebase/v1/delete
    getCategory() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
          .get(
              `${this.getOrganization}/setup/knowledgebase/category/${this.$ApiVersion}/request`,

              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.categories = response.data.Data;
                  setTimeout(() => {
                    this.create_success = null;
                    this.reload();
                  }, 2500);
                } else {
                  this.create_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                this.create_error = error.message;
              }
          );
    },
    deleteDocument( documentId ) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          KnowledgebaseId: documentId,
        },
      };

      axios
        .delete(
          `${this.getOrganization}/company/knowledgebase/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.del_success = response.data.StatusMessage;
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
              this.reload();
              setTimeout(() => {
                this.del_success = null;
              }, 2500);
            } else {
              this.del_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
              this.reload();
              setTimeout(() => {
                this.del_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            this.$notify.error({
              title: "Failure",
              message: error.message,
            });

            setTimeout(() => {
              this.del_error = null;
            }, 2500);
          }
        );
    },

    openPDFViewer(documentUrl, title, document) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        responseType: "arraybuffer",
      };

      this.attachmentType = documentUrl;
      this.docTitle = document.Description;

      axios
        .get(documentUrl, config)
        .then(async (response) => {
          // Check if the response data is a valid PDF
          if (response.headers["content-type"] === "application/pdf") {
            // Convert the response data (arraybuffer) to base64
            const arrayBuffer = response.data;

            // const byteArray = new Uint8Array(arrayBuffer);
            // let binaryString = "";
            // byteArray.forEach((byte) => {
            //   binaryString += String.fromCharCode(byte);
            // });
            // const base64String = btoa(binaryString);

            // Set the base64 string to attachmentUrl
            this.attachmentUrl = await mergePDFs(arrayBuffer);
          } else {
            // If it's not a valid PDF, it is treated as an image
            const blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            const url = URL.createObjectURL(blob);

            // Set the image URL to attachmentUrl
            this.attachmentUrl = url;
          }

          this.showAttachments = true;
        })
        .catch((error) => {
          this.get_error = error;
          setTimeout(() => {
            this.get_error = null;
          }, 2500);
        });
    },
    reload() {
      this.showCreateKnowledgeBaseDocument = false;
      this.getDocuments();
    },
    // /{organization}/company/knowledgebase/v1/request
    getDocuments() {
      this.loading = true;
      let url = `${this.getOrganization}/company/knowledgebase/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.tableData = response.data.Data;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },
  },
};
</script>
<style>
#downloadButton {
  display: none !important;
}
</style>
